function hasPermission (permissionsGranted, permissionsRequired) {
  return permissionsGranted && permissionsRequired.every(permissionRequired =>
    permissionsGranted.some(permissionGranted => permissionGranted.name === permissionRequired)
  )
}

module.exports = {
  hasPermission
}
